<template>
  <v-form ref="mainForm" v-model="valid">
    <CatalogueLive
      code="comite_ouinon"
      v-model="sas.sasEquivalence.desireAjouterComites"
      :live="{ endpoint: 'sas-equivalence', cle: '6147', fileId: sas.sasEquivalence.id }"
    />
    <data-iterator
      :list="sas.sasComite"
      add-new-text="Ajouter un comite"
      :live="{ endpoint: 'sas-comite', sasId: sas.id }"
      :icon="$getIcon('services')"
      :valids="valids"
      ref="dataIterator"
      :opqIf="estOui(sas.sasEquivalence.desireAjouterComites)"
    >
      <template v-slot:show-mode="{ item }">
        <p class="mb-0">{{ item.nomDuComite }}</p>
      </template>
      <template v-slot:edit-mode="{ item }">
        <TextFieldLive code="comite_nom" v-model="item.nomDuComite" :live="liveSasComites(8702, item)" />
        <MemoLive code="comite_mandat" v-model="item.mandat" :live="liveSasComites(8703, item)" />
        <DatePickerLive code="comite_debut" v-model="item.dateDebut" :live="liveSasComites(8705, item)" />
        <DatePickerLive code="comite_fin" v-model="item.dateFin" :live="liveSasComites(8704, item)" />
        <CatalogueLive code="comite_pays" v-model="item.pays" :live="liveSasComites(8706, item)" />
        <FileInput code="comite_preuve" :file="item.preuve" :live="liveSasComites(8707, item)" />
      </template>
    </data-iterator>
  </v-form>
</template>
<script>
import StepFormWithValidation from "@/mixins/StepFormWithValidation"
import CataloguesHelpers from "@/components/ui/mixins/CataloguesHelpers"

export default {
  mixins: [StepFormWithValidation, CataloguesHelpers],
  props: {
    sas: { type: Object }
  },
  methods: {
    liveSasComites(cle, item) {
      return { endpoint: "sas-comite", cle: cle, fileId: item.id }
    }
  }
}
</script>

<style>
</style>